// Angular
import { Injectable } from '@angular/core';

// RxJS
import { Observable, Subject } from 'rxjs';

export interface ISuccessStateService {
  successMessage$: Observable<string>;
  showSuccess(message: string): void;
  longSuccessMessage$: Observable<string>;
  showLongSuccess(message: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class SuccessStateService implements ISuccessStateService {

  private success$$ = new Subject<string>();
  successMessage$: Observable<string> = this.success$$.asObservable();

  private longSuccess$$ = new Subject<string>();
  longSuccessMessage$: Observable<string> = this.longSuccess$$.asObservable();


  showSuccess(message: string) {
    this.success$$.next(message);
  }

  showLongSuccess(message: string) {
    this.longSuccess$$.next(message);
  }
}
